export const defaultReducer = actions => (state, action) => {
  if (action.type === actions[action.type.name] && action.reducer)
    return action.reducer(state, action.payload)
  return state
}
